import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LocalDate } from '../../../store/models';

@Component({
  selector: 'ui-info-field-dates-with-divider',
  templateUrl: './info-field-dates-with-divider.component.html',
  styleUrls: ['./info-field-dates-with-divider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoFieldDatesWithDividerComponent {
  @Input() label: string;

  @Input() startDate: LocalDate;
  @Input() endDate: LocalDate;

  @Input() arrivalDeviation: string;
  @Input() departureDeviation: string;

  @Input() transitTime: string;
  @Input() transitDeviation: string;

  @Input() showWarningIcon: boolean;
  @Input() warningMessage: string;
}
